import React from "react";

/** PageHeader / hero 상단 — DetailSummaryButton 그룹 */
export function SettingsContentHeroActions({children}) {
    return (
        <div className="detail-tab-bar-hero__summary-actions asset-detail-summary-actions">
            {children}
        </div>
    );
}
